export default __webpack_public_path__ + "static/11-05d4e39fbecc1aecb80b8b82591b1ec2.webp";